import styled from 'styled-components';

// "+" reads thin and small at the button's base 12px font-size; bump
// the size and tighten line-height so the glyph fills the 14px slot
// at roughly the same visual weight as the folder / clock icons.
const NewChatIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-secondary);
`;

export default function NewChatIcon() {
  return (
    <NewChatIconSvg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M16.2426 12.0005H7.75736M12 16.2431V7.75781M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </NewChatIconSvg>
  );
}
